/* global Element */
/* global MutationObserver */
/* global crypto */
export function getClosest (elem, selector) {
  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function (s) {
        const matches = (this.document || this.ownerDocument).querySelectorAll(s)
        const i = matches.length
        // TODO: does this line of the function do anything at all if
        // returning an empty block from the while loop? - Testing removal.
        // while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1
      }
  }

  // Get the closest matching element
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem
  }
  return null
};

export function arraysMatch (arr1, arr2) {
  if (arr1.length !== arr2.length) return false
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false
  }
  return true
};

// Build timeouts into promises by using Promise.race with
// a provided promise (htp request, algolia, listen to DOM changes, ...)
// and a promise running a setTimeout
// Ignore the 3rd param if there's no need to tell apart timeout from
// promise exception
// Promise.race takes an iterable of promises and returns the first one settled (resolved/rejected)
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/race
export function timeoutHaltPromise (prom, time, exception) {
  let timer
  return Promise.race([
    prom,
    new Promise((resolve, reject) => timer = setTimeout(reject, time, exception))
  ]).finally(() => clearTimeout(timer))
}

export function waitElementPresence (parent, selector) {
  return new Promise(resolve => {
    if (parent.querySelector(selector)) {
      return resolve(parent.querySelector(selector))
    }

    const observer = new MutationObserver(_mutations => {
      if (parent.querySelector(selector)) {
        resolve(parent.querySelector(selector))
        observer.disconnect()
      }
    })

    observer.observe(parent, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false
    })
  })
}

export function uuidv4 () {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
